import type { Subscription } from "@/interfaces/subscription.interface";
import { createSlice } from "@reduxjs/toolkit";

interface UserType {
  id: string;
  name: string;
  email: string;
  email_verified_at: Date;
  phone: string;
  phone_verified_at: Date;
  is_default: boolean;
  is_main_business: boolean;
  is_owner: boolean;
  hotels: any[];
  restaurants: any[];
  business: any;
  subscriptions: Subscription[];
}
interface UserState {
  token?: string;
  user?: UserType;
  isAuthenticated: boolean;
  hotel?: any;
  restaurant?: any;
  current_subscription?: Subscription;
}

const initialState: UserState = {
  token: undefined,
  user: {} as UserType,
  isAuthenticated: false,
  hotel: undefined,
  restaurant: undefined,
  current_subscription: undefined,
};

const UserSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUser: (state, action) => {
      const { user } = action.payload;
      state.current_subscription = user.subscription;
      delete user.subscription;
      state.user = user;
    },
    signOut: () => initialState,
    signIn: (state, action) => {
      const { token, user } = action.payload;
      state.token = token;
      state.user = user;
      state.isAuthenticated = true;
    },
    setHotel: (state, action) => {
      const { hotel } = action.payload;
      state.hotel = hotel;
    },
    setRestaurant: (state, action) => {
      const { restaurant } = action.payload;
      state.restaurant = restaurant;
    },
  },
});

export const { setUser, signIn, signOut, setHotel, setRestaurant } = UserSlice.actions;
export default UserSlice.reducer;
